import { CheckCircle } from '@mui/icons-material';
import { Box, Container, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/Hooks';
import translator from '../theme/translator.json';
import Utils from '../utils/Utils';

const PurchaseSuccess: React.FC = () => {
  const language = useAppSelector((state) => state.user.language);

  const navigate = useNavigate();
  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          maxWidth: '900px',
          marginLeft: 'auto',
          marginRight: 'auto',
          gap: '15px',
          color: 'white',
        }}
      >
        <CheckCircle sx={{ fontSize: 150 }} />
        <Typography variant="h1">
          {Utils.getTranslation(language, translator.pages.purchaseSuccess.title)}
        </Typography>
        <Typography variant="body1" align="center">
          {Utils.getTranslation(language, translator.pages.purchaseSuccess.description)}
        </Typography>
        <Button onClick={() => navigate('/')} variant="contained">{Utils.getTranslation(language, translator.pages.notFound.toDashboard)}</Button>
      </Box>
    </Container>
  );
};

export default PurchaseSuccess;
